import React from 'react'
import Menu from '@/components/ui/Menu'
import { ReactComponent as CodeIcon } from '@/assets/icons/code.svg'
import Button from '@/components/ui/Buttons/Button'
import Typography from '@/components/ui/Typography'
import { HeaderTrigger } from '@/components/ui/Menu/Trigger'
import { Dropdown } from '@mui/base/Dropdown'
import { useQuery } from '@tanstack/react-query'
import { snippetsQueries, StudioSnippet } from '@/features/snippets'

export type SnippetsMenuProps = {
  onSelect: (snippet: StudioSnippet) => void
  onNewSelect: () => void
}

export const SnippetsMenu = ({ onSelect, onNewSelect }: SnippetsMenuProps) => {
  const query = useQuery(snippetsQueries.list())

  return (
    <Dropdown>
      <HeaderTrigger StartIcon={<CodeIcon />}>Snippets</HeaderTrigger>
      <Menu>
        <Menu.Body>
          {query.isLoading ? (
            <Typography>Loading</Typography>
          ) : (
            query.data?.map((snippet) => (
              <Menu.Item key={snippet.id} StartIcon={<CodeIcon />} onClick={() => onSelect(snippet)}>
                {snippet.name}
              </Menu.Item>
            ))
          )}
        </Menu.Body>
        <Menu.Footer>
          <Button color={'neutral'} variant={'outlined'} isStretched onClick={onNewSelect}>
            + Add new
          </Button>
        </Menu.Footer>
      </Menu>
    </Dropdown>
  )
}
